var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.384V14.43c0 .71.406 1.286.965 1.286h15.907c.559 0 .965-.582.965-1.285V1.383c0-.779-.363-1.384-.965-1.384H.965C.34 0 0 .62 0 1.384zM1.467 2.52c0-.314.148-.494.386-.494.147 0 5.927 4.688 6.277 4.963l.905.72c.287-.246.575-.456.872-.71.607-.497 6.006-4.973 6.154-4.973.238 0 .386.18.386.494 0 .333-.5.664-.827.919-2.05 1.6-4.1 3.343-6.13 5.002-.118.102-.348.322-.52.288-.191-.038-6.073-4.875-7.143-5.68-.161-.121-.36-.232-.36-.529z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconmin);
export default __webpack_public_path__ + "static/media/EmailIcon.min.15073e916faa3ca4ff186b407d5a58dd.svg";
export { ForwardRef as ReactComponent };